import Rewards from "views/Rewards";

export default Rewards